import { FormPropertyProps } from "../FormProperty";
import { Checkbox } from "./Values/Checkbox";
import { Numeric } from "./Values/Numeric";
import { Text } from "./Values/Text";
import { LongText } from "./Values/LongText";
import { Radio } from "./Values/Radio";
import { Date } from "./Values/Date";
import { Select } from "./Values/Select/Select";

export const FieldValue = (props: FormPropertyProps) => {
    const { property } = props;

    switch (property.field?.type) {
        case "number":
            return <Numeric {...props} />;

        case "text":
            return <Text {...props} />;

        case "long_text":
            return <LongText {...props} />;

        case "select":
            return <Select {...props} />;

        case "radio":
            return <Radio {...props} />;

        case "checkbox":
            return <Checkbox {...props} />;

        case "date":
            return <Date {...props} />;

        default:
            return <Text {...props} />;
    }
};
